import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../common/models/Error";
import { ClientsState } from "../models/ClientsState";

const setError = (state: ClientsState, action: PayloadAction<Error>) => {
    const { error } = action.payload;
    state.isError = error;
}

export default setError;